<script>
	export default {
		props: {
			tabClass: {
				required: true,
				type: String
			}
		},

		data() {
			return {
				activeTab: null
			}
		},

		mixins: [require('../../spark/mixins/tab-state')],

		mounted() {
			this.usePushStateForTabs('.' + this.tabClass);
		},

		watch: {
			activeTab(hash) {
				$('[href="#'+hash+'"]').click();
			}
		},

		methods: {
			/**
			 * override tab-state broadcast to update active tab
			 */
	        broadcastTabChange(hash, parameters) {
	        	this.activeTab = hash;
            	Bus.$emit('sparkHashChanged', hash, parameters);
			},

			/**
			 * Activate the first tab in a list.
			 */
			activateFirstTab() {
				const tab = $(`${this.pushStateSelector} a[data-toggle="tab"]`).first();
				console.log(tab);
				tab.tab('show');

				this.broadcastTabChange(tab.attr('href').substring(1));
			},
		}
	}
</script>
